export enum NotificationReadStatus {
    Readed = 1,
    NotYetRead = -1
}